import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'Tha',
  fallbackLocale: 'Tha',
  messages: {
    Tha: import(`../assets/lang/Tha.json`),
    Eng: import(`../assets/lang/Eng.json`)
  }
})

loadMessages()

export default i18n

export async function loadMessages() {
  const Tha = await import(`../assets/lang/Tha.json`)
  const Eng = await import(`../assets/lang/Eng.json`)
  i18n.setLocaleMessage('Tha', Tha)
  i18n.setLocaleMessage('Eng', Eng)
}
